module.exports = __webpack_public_path__ + "static/media/icon-arrow-down.8a50e8f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-arrow-down.svg
// module id = ./src/assets/images/icon-arrow-down.svg
// module chunks = 0